import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';

declare var require: any;
import Utils from 'src/app/utils';

@Component({
  selector: 'app-account-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  formGroup:any;

  submitted = false;
  card_notice:any;

  countries:any;

  processing = false;
  
  months = [{val:'01',lab:'Jan'},{val:'02',lab:'Feb'},{val:'03',lab:'Mar'},{val:'04',lab:'Apr'},{val:'05',lab:'May'},{val:'06',lab:'June'},{val:'07',lab:'July'},{val:'08',lab:'Aug'},{val:'09',lab:'Sept'},{val:'10',lab:'Oct'},{val:'11',lab:'Nov'},{val:'12',lab:'Dec'}];

  years = [{val:'25',lab:'2025'},{val:'26',lab:'2026'},{val:'27',lab:'2027'},{val:'28',lab:'2028'},{val:'29',lab:'2029'},{val:'30',lab:'2030'},{val:'31',lab:'2031'},{val:'32',lab:'2032'},{val:'33',lab:'2033'},{val:'34',lab:'2034'},{val:'35',lab:'2035'},{val:'36',lab:'2036'},{val:'37',lab:'2037'},{val:'38',lab:'2038'},{val:'39',lab:'2039'},{val:'40',lab:'2040'}];

  canadian_states = [
    {"code":"BC","name":"British Columbia"},
    {"code":"ON","name":"Ontario"},
    {"code":"ON","name":"Newfoundland and Labrador"},
    {"code":"NS","name":"Nova Scotia"},
    {"code":"PE","name":"Prince Edward Island"},
    {"code":"NB","name":"New Brunswick"},
    {"code":"QC","name":"Quebec"},
    {"code":"MB","name":"Manitoba"},
    {"code":"SK","name":"Saskatchewan"},
    {"code":"AB","name":"Alberta"},
    {"code":"NT","name":"Northwest Territories"},
    {"code":"NU","name":"Nunavut"},
    {"code":"YT","name":"Yukon Territory"},
  ]

  confirm = false;


  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) {

    this.countries = Utils.getCountries();
  }

  ngOnInit(): void {    

    this.setForm();

    

  }

  setForm(){
    this.formGroup = new FormGroup({
      card_name: new FormControl('',[Validators.required]),
      card_number: new FormControl('',[Validators.required]),
      card_month: new FormControl('01',[Validators.required]),
      card_year: new FormControl('25',[Validators.required]),
      card_cvv: new FormControl('',[Validators.required]),
  
      address1: new FormControl('',[Validators.required]),
      city: new FormControl('',[Validators.required]),
      state: new FormControl('',[Validators.required]),
      postcode: new FormControl('',[Validators.required]),
      country: new FormControl(this.okService.settings.country,[Validators.required]),
      
      phone: new FormControl(this.okService.me.phone,[Validators.required]),
      email: new FormControl(this.okService.me.email,[Validators.required]),
      agree_terms:new FormControl(false,[Validators.required]),
  
    })
  }

  submitForm(){
    this.submitted = true;
    this.card_notice = null;

    if (this.formGroup.valid) {
        let values = this.formGroup.value
        //console.log(values);

        this.processing = true;

        this.okService.post("billing/card",{card:values})
        .subscribe((data) => {

          let response:any = data.body;

          this.card_notice = response;
          
          //console.log(this.card_notice.success && !this.okService.billing.live);

          this.processing = false;

          // If not live see if they are now live
          if(this.card_notice.success && !this.okService.billing.live){

            //console.log("Update the billing");

            this.okService.get("billing",{})
            .subscribe((data:any) => {
              
              this.okService.billing = data.body;

              if(this.okService.billing.live){
                this.router.navigateByUrl('/account');
              }
        
            })

          }

          
        });

      }

    return false;
  }
}
